import { useEffect } from 'react';

function isLocalHost(hostname: string) {
  return !!(
    hostname === 'localhost' ||
    hostname === '[::1]' ||
    hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
  );
}

export default function useHttpsRedirect() {
  const shouldRedirect =
    process.env.REACT_APP_FE_ENV === 'production' &&
    typeof window !== 'undefined' &&
    window.location &&
    window.location.protocol === 'http:' &&
    !isLocalHost(window.location.hostname);
  useEffect(() => {
    if (shouldRedirect) {
      window.location.href = window.location.href.replace(/^http(?!s)/, 'https');
    }
  }, [shouldRedirect]);
}
